import type { ReactElement } from 'react'
import React, { Children } from 'react'
import BulkActions from './BulkActions'
import GlobalActions from './GlobalActions'
import { useTable } from './TableContext'
import Title from './Title'

interface HeaderProps {
  children: ReactElement | ReactElement[]
}

function Header({ children }: HeaderProps): JSX.Element {
  const [state] = useTable()
  const components: Record<string, ReactElement | null> = {
    bulkActions: null,
    globalActions: null,
    title: null,
  }

  // TODO: This is written like this because Typescript complains when trying to access `child.type.name`. We need to figure out a way to type the child appropriately.
  Children.forEach(children, (child) => {
    switch (child.type) {
      case BulkActions:
        components.bulkActions = child
        break
      case GlobalActions:
        components.globalActions = child
        break
      case Title:
        components.title = child
        break
    }
  })

  const bulkable =
    state.rows.filter((row) => row.selected).length > 0 &&
    components.bulkActions

  if (bulkable) {
    return (
      <div className="px-6 py-4 bg-primary-20">{components.bulkActions}</div>
    )
  }

  return (
    <div className="flex items-center justify-between px-6 py-4">
      {components.title}
      {components.globalActions}
    </div>
  )
}

export default Header
